import { Link, graphql, useStaticQuery } from "gatsby"
import React from "react"
import * as style from "./style.module.css"
import BackgroundMedia from "/src/components/BackgroundMedia"
import { formatDate } from "/src/utils/formatDate"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

const linkPrefix = getPathFromTemplateType(4).replace(/\/p\/1/g, "")

const Component = ({ article }) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "picture/blog_sample.jpg" }) {
        publicURL
      }
    }
  `)

  return (
    <Link className={style.container} to={`${linkPrefix}/${article.slug}`}>
      {/* <div className={style.thumbnail}>
        {article.media ? (
          <BackgroundMedia media={article.media} />
        ) : (
          <BackgroundMedia media={{ url: data.file.publicURL, type: 1 }} />
        )}
      </div> */}
      <time dateTime={article.createTime}>
        {formatDate(article.createTime)}
      </time>
      <p>{article.title}</p>
    </Link>
  )
}

export default Component
